import { createContext, useContext } from 'react';
export const WixRicosViewerContext = /*#__PURE__*/createContext(undefined);
export function useWixRicosViewer() {
  const context = useContext(WixRicosViewerContext);
  if (context === undefined) {
    throw new Error('useWixRicosViewer must be used within a WixRicosViewerContext.Provider');
  }
  return context;
}
//# sourceMappingURL=ricos-viewer-context.js.map